import { createApi } from '@reduxjs/toolkit/query/react';
import { NetworkService } from 'services';
import { cacheTags } from 'constants/cacheTags';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: NetworkService.baseQuery,
  tagTypes: Object.values(cacheTags),
  endpoints: () => ({}),
});
